import React from 'react';
import styled from 'styled-components';

const AnimationControlsStyle = styled.div`
    display: flex;
    /* background: rgba(0, 0, 0, 0.5); */
    margin: 0 auto;
    padding: 10px;
    justify-content: space-around;
    position: absolute;
    width: 200px;
    height: 200px;
    font-size: 40px;
    text-transform: uppercase;
    z-index: 100000;
    bottom: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    opacity: 0;
    transition: all 300ms linear;
    ${props => {
        if (props.pause) {
            return `
      opacity: 1;
      `;
        }
    }} a {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        text-align: center;
        box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
        font-weight: bold;
        background: white;
        color: gray;
        transition: all 300ms linear;
        opacity: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
            cursor: pointer;
            color: black;
            opacity: 1;
        }
    }

    /* ----- small btn ------ */
    width: 70px;
    height: 70px;
    font-size: 10px;
    top: auto;
    left: auto;
    right: 0;
    bottom: 0;
    pointer-events: all;
    /* ---------------------- */
`;

class AnimationControls extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pause: !props.startAnimation,
        };
    }

    componentDidMount() {
        window.addEventListener('animationCompleted', this.handleAnimationCompleted, false);
        window.addEventListener('restartAnimation', this.handleAnimationRestart, false);
        window.addEventListener('resetAnimation', this.handleAnimationReset, false);
    }

    componentWillUnmount() {
        window.removeEventListener('animationCompleted', this.handleAnimationCompleted, false);
        window.removeEventListener('restartAnimation', this.handleAnimationRestart, false);
        window.removeEventListener('resetAnimation', this.handleAnimationReset, false);
    }

    handleAnimationCompleted = () => {
        this.setState({
            completed: true,
            pause: true,
        });
    };

    handleAnimationRestart = () => {
        this.setState({
            completed: false,
            pause: false,
        });
    };

    handleAnimationReset = () => {
        this.setState({
            completed: false,
            pause: true,
        });
    };

    handleButtonAction = () => {
        const { pause, completed } = this.state;
        const { noAnimationControls } = this.props;

        if (noAnimationControls) {
            window.dispatchEvent(new Event('startAnimation'));
            return;
        }
        if (pause && completed) window.dispatchEvent(new Event('restartAnimation'));
        if (pause) window.dispatchEvent(new Event('playAnimation'));
        if (!pause) window.dispatchEvent(new Event('pauseAnimation'));
    };

    render() {
        const { pause, completed } = this.state;
        const { video, screencast, noAnimationControls } = this.props;
        if (!video || screencast) return null;

        if (noAnimationControls && (!pause || completed)) {
            return null;
        }

        return (
            <AnimationControlsStyle pause={pause} className="animation-controls">
                <a
                    onClick={() => {
                        this.handleButtonAction();
                        this.setState({
                            pause: !pause,
                            completed: completed ? !completed : completed,
                        });
                    }}
                >
                    {completed && 'Replay'}
                    {pause && !completed && 'Play'}
                    {!pause && !completed && 'Pause'}
                </a>
            </AnimationControlsStyle>
        );
    }
}

export default AnimationControls;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/animated/views/AnimationControls.js
 **/